import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getAuthHeader = () => {
  const token = sessionStorage.getItem('cfe_session_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};
